module.exports = __webpack_public_path__ + "static/button-70ece25e1360c8bddf35939322a81291.png";